import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import App from "./App";
import * as serviceWorker from "./serviceWorker";
import createSagaMiddleware from "redux-saga";
import { Provider } from "react-redux";
import { createStore, applyMiddleware } from "redux";
import rootSaga from "./redux/saga";
import reducer from "./redux/reducers";
import { Helmet } from "react-helmet";

const sagaMiddleware = createSagaMiddleware();

const store = createStore(reducer, applyMiddleware(sagaMiddleware));
sagaMiddleware.run(rootSaga);

ReactDOM.render(
  <Provider store={store}>
    <React.StrictMode>
      <Helmet>
        <script type="text/javascript">
          {`
        window._mfq = window._mfq || [];
        (function() {
          var mf = document.createElement("script");
          mf.type = "text/javascript"; mf.defer = true;
          mf.src = "//cdn.mouseflow.com/projects/1ce0fbf8-1665-4898-834c-6b0460cf0ff7.js";
          document.getElementsByTagName("head")[0].appendChild(mf);
        })();
        `}
        </script>
      </Helmet>
      <App />
      <div className="loaderElement">
        <div className="loader-back" />
        <div className="loaderImage" />
      </div>
    </React.StrictMode>
  </Provider>,
  document.getElementById("root")
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.register();
